import React, { useEffect } from 'react';
import { StepNavigationHeader } from '../Shared/Widgets/StepsNavigationHeader/StepsNavigationHeader';

import Breadcrumbs from '@shared/Widgets/Navigation/Breadcrumbs/Breadcrumbs';
import { BREADCRUMBS_LABELS } from '@configs/BreadcrumbsLabels';
import { useMediaType } from '@shared/Hooks/useMediaTypeHook';
import { useParams } from 'react-router-dom';
import { StepsViewModeEnum } from '@shared/Enums/StepsViewModeEnum';
import Step1 from '@modules/Steps/Components/Step1/Step1';

const Step1Page: React.FC = () => {
    const [isDesktop] = useMediaType();
    return (
        <>
            {isDesktop && (
                <Breadcrumbs items={BREADCRUMBS_LABELS.CREATE_NEW_PROJECT} />
            )}
            <StepNavigationHeader />
            <Step1 />
        </>
    );
};

export default Step1Page;
